// extracted by mini-css-extract-plugin
module.exports = {"TooltipIcon":"InfoTooltip_TooltipIcon__mEwDm"};